import React, { Component } from "react";
import { Backdrop, Block, Overlay } from "reakit";
import { FilterOverlay } from "../Search/styles";
import HealthAdminHistory from "./HealthAdminHistory";

class HealthAdminHistoryPopup extends Component {
  render() {
    const {
      visible,
      toggle,
      selected,
      selectedIsStudent,
      firebase,
    } = this.props;
    return (
      <div>
        <Overlay.Container>
          {(overlay) => (
            <Block>
              <Backdrop fade {...overlay} visible={visible} onClick={toggle} />
              <FilterOverlay
                fade
                {...overlay}
                visible={visible}
                padding={0}
                margin={0}
              >
                <HealthAdminHistory
                  selected={selected}
                  selectedIsStudent={selectedIsStudent}
                  firebase={firebase}
                />
              </FilterOverlay>
            </Block>
          )}
        </Overlay.Container>
      </div>
    );
  }
}

export default HealthAdminHistoryPopup;
